import { useLocation } from '@tanstack/react-router'

import { useComponentTranslation } from '@/hooks/use-component-translation'
import { usePageTitle } from '@/hooks/use-page-title'
import { findPageTitleKey, pageTitleLocales } from '@/lib/page-titles'

/**
 * Component that automatically manages the page title based on the current route.
 *
 * Should be placed in the main layout (AppLayout or RootLayout) to
 * automatically update the title when the user navigates.
 *
 * For routes with specific layouts (settings, reports), the child layout
 * can use usePageTitle directly for more specific titles.
 */
export function PageTitleManager() {
  const location = useLocation()
  const { t } = useComponentTranslation(pageTitleLocales)

  const titleKey = findPageTitleKey(location.pathname)
  const title = titleKey ? t(titleKey) : undefined

  usePageTitle(title)

  return null
}
